import { BookingRulesSettings } from '../payload/create-booking-rules.payload';

export enum BookingRulesType {
  HOURLY = 'HOUR',
  DAILY = 'DAY',
}

export enum SpaceType {
  DESK = 'DESK',
  ROOM = 'ROOM',
}

export interface BookingRulesResponse {
  token: string;
  name: string;
  durationType: BookingRulesType;
  rules: BookingRulesSettings;
  tenantToken: string;
  assignedEmployeeGroups: {
    token: string;
    spaceType: SpaceType;
  }[];
}
